export const genericServerMessageEnum = {
    OK: 'OK',
    KO: 'KO'
}

export const rolesEnum = {
    ROLE_ADMIN: 'ROLE_ADMIN',
    ROLE_USER: 'ROLE_USER'
}

export const operationTypeEnum = {
    GIFT: 1,
    BORROWING: 2,
    EXCHANGE: 3
}

export const operationTypeNumericEnum = {
    1: 'GIFT',
    2: 'BORROWING',
    3: 'EXCHANGE'
}

export const operationStatusEnum = {
    CREATED: 1,
    APPROVED_BY_ADMIN: 2,
    REJECTED_BY_ADMIN: 3,
    REJECTED: 4,
    WAITING_DEAL_CONFIRMATION: 5,
    CANCELED: 6,
    DEAL_CONFIRMED_BY_SENDER: 7,
    DEAL_CONFIRMED_BY_RECEIVER: 8,
    IN_PROGRESS: 9,
    RETRIEVED_BY_SENDER: 10,
    RETRIEVED_BY_RECEIVER: 11,
    COMPLETED: 12
}

export const operationStatusNumericEnum = {
    1: 'CREATED',
    2: 'APPROVED_BY_ADMIN',
    3: 'REJECTED_BY_ADMIN',
    4: 'REJECTED',
    5: 'WAITING_DEAL_CONFIRMATION',
    6: 'CANCELED',
    7: 'DEAL_CONFIRMED_BY_SENDER',
    8: 'DEAL_CONFIRMED_BY_RECEIVER',
    9: 'IN_PROGRESS',
    10: 'RETRIEVED_BY_SENDER',
    11: 'RETRIEVED_BY_RECEIVER',
    12: 'COMPLETED'
}

export const socketMessageTypeEnum = {
    CHAT_MESSAGE: 'CHAT_MESSAGE',
    FREE_CHAT_MESSAGE: 'FREE_CHAT_MESSAGE',
    OPERATION_UPDATE: 'OPERATION_UPDATE',
    UNREAD_NOTIFICATIONS_COUNT: 'UNREAD_NOTIFICATIONS_COUNT',
    OPERATION_INCIDENCE: 'OPERATION_INCIDENCE',
    BOOK_RETURN_REMINDER: 'BOOK_RETURN_REMINDER'
}